import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchPublicFavouriteGames, fetchPublicLabels, retrievePublicUserInfo } from "../../../functions/publicapi";
import { ROUTE_PAGE_NOT_FOUND } from "../../../functions/route";
import { getLabelFilter, toggleLabel } from "../../../functions/labelUtils";
import Loader from "../../Loader";
import BottomAnchor from "../../privatearea/BottomAnchor";
import PageLayout from "../../PageLayout";
import PublicFavouriteGameDisplayer from "./game/PublicFavouriteGameDisplayer";
import PublicGameLabelDisplayer from "./gamelabel/PublicGameLabelDisplayer";

function PublicGamesAndLabels({ onError }) {
    const { t } = useTranslation('messages');
    let navigate = useNavigate();

    const [searchParams] = useSearchParams();
    let gameLinkId = searchParams.get('game_link_id');

    const [user, setUser] = useState(null);
    const [games, setGames] = useState([]);
    const [labels, setLabels] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState(new Map());

    useEffect(() => {
        fetchPublicFavouriteGames(gameLinkId, (data) => setGames(data.gamesWithLabels), () => navigate("/" + ROUTE_PAGE_NOT_FOUND), {});
        fetchPublicLabels(gameLinkId, (data) => setLabels(data.labels), () => navigate("/" + ROUTE_PAGE_NOT_FOUND));
        retrievePublicUserInfo(gameLinkId, (data) => setUser(data.user), () => navigate("/" + ROUTE_PAGE_NOT_FOUND));
    }, [gameLinkId, navigate]);

    if (!user) {
        return (
            <Container fluid className="home-hero d-flex align-items-center justify-content-center"
                style={{ minHeight: 'calc(100vh - 56px)' }}>
                <Loader isError={false} />
            </Container>
        );
    }

    return (
        <>
            <PageLayout
                hero={
                    <>
                        <h1 className="display-5 fw-bold mb-3">
                            {t('public_area.games.owner', { name: user.firstname })}
                        </h1>
                        <h6 className="text-white-50 mb-3">{t('public_area.games.labels_title')}</h6>
                        <PublicGameLabelDisplayer
                            gameLabels={labels}
                            checkedLabels={checkedLabels}
                            checkLabel={(labelId) => onCheckLabelClicked(gameLinkId, labelId, checkedLabels, setCheckedLabels, setGames, onError)}
                        />
                    </>
                }
            >
                <h2 className="fw-bold mb-3">{t('public_area.games.games_title')}</h2>
                <PublicFavouriteGameDisplayer favouriteGames={games} />
            </PageLayout>

            <BottomAnchor favouriteGames={games} />
        </>
    );
}

function onCheckLabelClicked(gameLinkId, labelId, checkedLabels, setCheckedLabels, setGames, onError) {
    const newCheckedLabels = toggleLabel(labelId, checkedLabels);
    fetchPublicFavouriteGames(gameLinkId, (data) => {
        setGames(data.gamesWithLabels);
        setCheckedLabels(newCheckedLabels);
    }, onError, getLabelFilter(newCheckedLabels));
}

export default PublicGamesAndLabels;
